<!--suppress ALL -->
<template>
  <label :class="className" :disabled="disabled">
    <input v-model="computedValue" :disabled="disabled" :name="name" :id="id"
           :indeterminate.prop="null" type="checkbox" :value="nativeValue"
           :true-value="trueValue" :false-value="falseValue" @change="onChange">
    <span class="checked"></span>
    <span v-if="$scopedSlots.default || $slots.default" class="control"><slot/></span>
  </label>
</template>

<script lang="ts">
  import {Component, Vue, Prop, Watch} from 'annotation';

  @Component
  export default class GCheckbox extends Vue {

    @Prop({default: '', type: String})
    public name: string;

    @Prop({default: null, type: String})
    public id: string;

    @Prop()
    public value;

    @Prop({default: true})
    public trueValue: any;

    @Prop({default: false})
    public falseValue: any;

    @Prop()
    public disabled: boolean;

    @Prop({default: false})
    public indeterminate: any;

    @Prop()
    public nativeValue: any;

    @Watch('value')
    public onValueChange(value) {
      this.newValue = value;
    }

    @Prop({default: '', type: String})
    public type: string;

    public newValue: any = this.value;

    public get computedValue() {
      return this.newValue;
    }

    public set computedValue(value) {
      this.newValue = value;
      this.$emit('input', value);
    }

    public get alterClassName() {
      if (this.$parent.isFieldComponent && this.$parent.type.length) {
        return 'is-' + this.$parent.type;
      }

      return '';
    }

    public onChange(e) {
      // console.log(e && e.target && e.target.checked);
      this.$emit('change', e && e.target && e.target.checked);
    }

    public get className() {
      const {type, alterClassName}: GCheckbox = this;
      const typeClassName = type ? ('is-' + type) : '';

      return [typeClassName, alterClassName].reduce((accu, item) =>
        accu + (item ? (item + ' ') : ''), 'g-checkbox checkbox ');
    }
  }
</script>

<style lang="scss">
  @import "../../../../style/variables_function";

  .g-checkbox.checkbox {
    input[type=checkbox] {
      &:checked + .checked {
        background: $grey-darker url(checkmark($white-ter)) no-repeat center center;
      }

      &:not(:checked) + .checked {
        background-color: white;
        box-sizing: border-box;
      }

      &:indeterminate + .checked {
        background: $grey-darker url(indeterminate($white-ter)) no-repeat center center;
      }
    }

    .checked {
      width: 1.25em;
      height: 1.25em;
      flex-shrink: 0;
      border-radius: 5px;
      border: 2px solid $grey-darker;

      + .control {
        margin-left: .5rem;
      }
    }

    @each $name, $pair in $colors_type {
      &.is-#{$name} {
        $color: nth($pair, 1);
        $color-invert: nth($pair, 2);

        .checked {
          border: 2px solid $color;
        }

        input[type=checkbox]:checked + .checked {
          background: $color url(checkmark($color-invert)) no-repeat center center;
        }

        input[type=checkbox]:indeterminate + .checked {
          background: $color url(indeterminate($color-invert)) no-repeat center center;
        }
      }
    }
  }
</style>
